import React, { useRef } from "react";
import { Link } from "react-router-dom";
import StackingCards, { StackingCardItem } from "../../../components/ui/stacking-cards";
import { cn } from "../../../lib/utils";

const cards = [
  {
    bgColor: "bg-[#3F5646]",
    title: "Artificial Intelligence",
    description:
      "From the fundamentals to building your own AI tools. Understand the technology reshaping every industry, and learn to build with it, not just talk about it.",
    image: "https://images.unsplash.com/photo-1518770660439-4636190af475?q=80&w=1200",
  },
  {
    bgColor: "bg-[#1b1b1b]",
    title: "Blockchain & Digital Assets",
    description:
      "Smart contracts, tokenization, and the infrastructure quietly becoming the backbone of how value moves. Learn what is actually happening under the hood, not just the headlines.",
    image: "https://images.unsplash.com/photo-1621504450181-5d356f61d307?q=80&w=1200",
  },
  {
    bgColor: "bg-[#344532]",
    title: "Stablecoins & DeFi",
    description:
      "Money is becoming programmable. Our Stablecoin Academy walks you from fundamentals to real payment infrastructure, how digital money moves across borders, platforms, and financial systems.",
    image: "https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?q=80&w=1200",
  },
  {
    bgColor: "bg-[#5196fd]",
    title: "Business, Finance & Entrepreneurship",
    description:
      "Build something that lasts. Practical finance, core business fundamentals, and the entrepreneurial thinking behind ideas that actually launch, not just theory.",
    image: "https://images.unsplash.com/photo-1524178232363-1fb2b075b655?q=80&w=1200",
  },
  {
    bgColor: "bg-[#212B24]",
    title: "Cybersecurity, IoT & Emerging Tech",
    description:
      "IoT, cybersecurity, and the technologies shaping what comes after Web3. Build the knowledge to work at the edge of what is next, instead of catching up once it is mainstream.",
    image: "https://images.unsplash.com/photo-1451187580459-43490279c0fa?q=80&w=1200",
  },
];

export default function StackingCardsShowcase() {
  const container = useRef(null);

  return (
    <div className="h-[620px] bg-white overflow-auto text-white" ref={container}>
      <StackingCards totalCards={cards.length} scrollOptions={{ container }}>
                                <div className="relative h-[110px] w-full z-10 text-3xl md:text-5xl font-bold tracking-tighter flex justify-center items-center text-black whitespace-pre">
          Explore learning tracks ↓
        </div>
        {cards.map(({ bgColor, description, image, title }, index) => {
          return (
            <StackingCardItem key={index} index={index} className="h-[620px]">
              <div
                className={cn(
                  bgColor,
                  "h-[80%] sm:h-[70%] flex-col sm:flex-row aspect-video px-8 py-10 flex w-11/12 rounded-3xl mx-auto relative"
                )}
              >
                                <div className="flex-1 flex flex-col justify-center">
                  <h3 className="font-bold text-2xl mb-5">{title}</h3>
                  <p>{description}</p>
                  <span className="flex items-center gap-2 pt-4">
                    <Link to="/course-catalog" className="underline cursor-pointer">
                      See more
                    </Link>
                    <svg width="22" height="12" viewBox="0 0 22 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M21.5303 6.53033C21.8232 6.23744 21.8232 5.76256 21.5303 5.46967L16.7574 0.696699C16.4645 0.403806 15.9896 0.403806 15.6967 0.696699C15.4038 0.989592 15.4038 1.46447 15.6967 1.75736L19.9393 6L15.6967 10.2426C15.4038 10.5355 15.4038 11.0104 15.6967 11.3033C15.9896 11.5962 16.4645 11.5962 16.7574 11.3033L21.5303 6.53033ZM0 6.75L21 6.75V5.25L0 5.25L0 6.75Z"
                        fill="white"
                      />
                    </svg>
                  </span>
                </div>

                <div className="w-full sm:w-1/2 rounded-xl aspect-video relative overflow-hidden">
                  <img
                    src={image}
                    alt={title}
                    className="absolute inset-0 w-full h-full object-cover"
                  />
                </div>
              </div>
            </StackingCardItem>
          );
        })}

        <div className="w-full h-80 relative overflow-hidden">
                    <h2 className="absolute bottom-0 left-0 translate-y-1/3 sm:text-[192px] text-[80px] text-[#ff5941] font-calendas">
          </h2>
        </div>
      </StackingCards>
    </div>
  );
}